import './components/App.css';
import Login from './components/Login'
import Gen from './components/Generate';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
let App = ()=> {
  return(
    <Router>
      <div className="MainPage">
        <h1 className='AppHead'>
          Web-Application-Assesment
        </h1>
        <Routes>
          <Route path="/" element={<Login/>}/>
          <Route path="/generate" element={<Gen/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;


 